import React, { useState } from 'react';
import BottomNav from '../components/BottomNav';
import SearchBar from '../components/SearchBar';

const Network = () => {
  const [searchTerm, setSearchTerm] = useState('');
  
  const members = [
    { name: 'Alexandra Smith', title: 'CEO, Tech Innovations', location: 'Cape Town', tier: 'Privé' },
    { name: 'Michael Chen', title: 'Investment Banker', location: 'Johannesburg', tier: 'Gold' },
    { name: 'Sarah Johnson', title: 'Real Estate Developer', location: 'Durban', tier: 'Privé' },
    { name: 'David Martinez', title: 'Entrepreneur', location: 'Pretoria', tier: 'Gold' },
    { name: 'Emma Wilson', title: 'Fashion Designer', location: 'Cape Town', tier: 'Supercar Club' },
  ];
  
  const filteredMembers = members.filter(member =>
    member.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    member.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    member.location.toLowerCase().includes(searchTerm.toLowerCase())
  );
  
  return (
    <div className="page-container">
      <div className="page-wrapper">
        <h1 className="page-title">Member Network</h1>
        <div className="underline"></div>
        <p className="page-subtitle">Connect with Elite Members</p>
        
        <SearchBar 
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search members..."
        />
        
        <div style={{marginTop: '2rem'}}>
          {filteredMembers.map((member, index) => (
            <div key={index} className="card" style={{marginBottom: '1rem'}}>
              <div style={{display: 'flex', alignItems: 'center', gap: '1rem'}}>
                <div style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, var(--gold), var(--silver))',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.5rem',
                  fontWeight: 'bold',
                  color: 'black'
                }}>
                  {member.name.split(' ').map(n => n[0]).join('')}
                </div>
                
                <div style={{flex: 1}}>
                  <h3 style={{margin: '0 0 0.25rem 0'}}>{member.name}</h3>
                  <p style={{margin: '0', fontSize: '0.9rem', opacity: 0.8}}>{member.title}</p>
                  <p style={{margin: '0.25rem 0 0 0', fontSize: '0.85rem', opacity: 0.6}}>
                    📍 {member.location} • {member.tier}
                  </p>
                </div>
                
                <button className="btn-secondary" style={{padding: '0.5rem 1rem'}}>
                  Connect
                </button>
              </div>
            </div>
          ))}
          
          {filteredMembers.length === 0 && (
            <p style={{textAlign: 'center', opacity: 0.6, marginTop: '2rem'}}>
              No members found matching "{searchTerm}"
            </p>
          )}
        </div>
      </div>
      
      <BottomNav />
    </div>
  );
};

export default Network;
